import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _DocumentatioPage, _single } from "../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../theme/Component/usePaginator";
import { useEffect, useState } from "react";
import { BasicTable, MASK_DATE } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { SelectDocumentatioPage } from "./SelectDocumentatioPage";
import { EditorDocumentatioPage } from "./EditorDocumentatioPage";


interface Props {
    UrlMenu: string;
}

export const DocumentatioPage = ({ UrlMenu }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_DocumentatioPage);
    const paginador = usePaginator();
    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Documentación", MODAL_SM);
    const modalDoc = useModal("", MODAL_XL);

    const [response, setResponse] = useState<any>("");

    useEffect(() => {
        if (UrlMenu) {
            getLista();
        }
    }, [UrlMenu])

    const getLista = () => {
        const props: any = {
            ApplicationIDUrl: UrlMenu,
        }
        instance.getPageDocumentationRender(paginador.page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List);
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDDocumentatioPage', visible: true },
        { title: 'Nombre pagina', property: 'PageName', visible: true },
        { title: 'Url Sistema', property: 'ApplicationIDUrl', visible: true },
        { title: 'Actualizacion', property: 'LastUpdate', visible: true },
    ];

    const getDocumentInfo = () => {
        instance.getPageDocumentationHtml(bean.IDBookPage).then(
            (resp) => {
                setResponse(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    useEffect(() => {
        if (response) {
            modalDoc.open()
        }
    }, [response])


    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            ApplicationIDUrl: UrlMenu,
            LastUpdate: _single.getCurrenDate(),
        });
        modal.open("Agregar Documentación");
    }

    const deleteItem = () => {
        // const x = { ...bean, State: 2 };
        // editaItem(x);
        instance.deleteDocumentatioPage(bean.IDDocumentatioPage).then(
            (resp) => {
                getLista();
                modalC.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    };

    const editaItem = (obj: any) => {
        instance.updateDocumentatioPage(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-eye-line', visible: _single.canEdit(), evento: () => { getDocumentInfo() } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} records={paginador} />

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar Documento {bean.PageName}</strong>
                </ModalConfirm>

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem({ ...bean, IDEmployee: _single.getAccountID(), LastUpdate: _single.getCurrenDate() }) }} >
                    <div className="row">
                        <div className="col-md-12">
                            <EditorDocumentatioPage IDSelect={bean.IDBookPage} onChange={(e) => { setBean({ ...bean, IDBookPage: e?.PageID, PageName: e?.Name }) }} label="Documentos Disponibles" />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                    <iframe
                        srcDoc={response}
                        style={{ width: "100%", height: "75vh" }}
                    />
                </Modal>

            </div>
        </div>
    )
}